import { FC } from 'react';
import Modal from '@new/common/ui/Modal/Modal';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ContactModal: FC<ContactModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Contact Us" className="gap-0! w-6xl h-[80vh]">
      <div className="flex h-full min-h-0 flex-col gap-4">
        <iframe
          src="https://api.leadconnectorhq.com/widget/form/A2nuCk56bnyaUrtY1DFu"
          className="min-h-0 flex-1 border-0"
          title="Student Tickets Form"
        />
      </div>
    </Modal>
  );
};
